
 const stepStyle = {
  root: {
    backgroundColor: 'rgba(0, 0, 0, 0) !important' ,
    paddingTop: "0px !important",
    padding:"0px !important"
  }
};

export default stepStyle;
